const NotFoundPage = () => {
    return <h1 className="my-auto">功能即将上线, 敬请期待</h1>
}

export default NotFoundPage